import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import { urlParams, getPageLayoutType, validateEmailFunc, decode_utf8 } from '../../../../common/utils/utilsFunc'
import DebtAndEndowmentContextProvider, { ACTIONS, DebtAndEndowmentContext } from '../../context/DebtAndEndowmentContextProvider';
import Loading from "../../../../common/components/Loading";
import AlertModal from '../../../../common/components/AlertModal';
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function DebtAndEndowmentPublic({ props, title, description, typeCertificate, canal }) {
  const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [state, dispatch] = React.useContext(DebtAndEndowmentContext);
  const [numberClient, setNumberClient] = React.useState()
  const [errorToggle, setErrorToggle] = React.useState(false);
  const [valueCheckBox, setValueCheckBox] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [emptyError, setEmptyError] = React.useState(false);
  const [validateEmail, setValidateEmail] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [handleButton, setHandleButton] = React.useState(false);
  const [visibleModal, setVisibleModal] = React.useState(false);
  const [visibleModal2, setVisibleModal2] = React.useState(false);
  const [confirm, setConfirm] = React.useState(false);
  const { observer, onClose } = useModal({
    onClose: () => {
      setVisibleModal(false);
      setVisibleModal2(false);
    }
  });

  const [detailClientJson, setDetailClientJson] = React.useState([])
  const [values, setValues] = React.useState({
    idClient: '',
    nameClient: '',
    email: '',
    emailConfirm: '',
    cellphone: ''
  })
  const [errorCli, setErrorCli] = React.useState(false);
  const [disabledButton, setDisabledButton] = React.useState(true);
  const [inputValidate, setInputValidate] = React.useState({
    empty: {},
    validated: {},
    msg: {}
  });
  const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


  let propsLabelInfoContent = {
    "content": state?.webContentTextInfo,
    "observer": observer,
    "onClose": onClose,
    "setVisibleModal": setVisibleModal2,
    "status": "info",
    "titleModal": "Información",
    "visibleModal": visibleModal2,
    "titleHint": "Ayuda Nro de Cliente",
  }

  function onChangeReCaptcha(value) {
    updateCookieState(value);
    if (value) {
      setVerifReCaptcha(true);
    }
    else {
      setVerifReCaptcha(false);
    }
  }

  function handleClickButton() {
    if (validateEmail && !valueCheckBox) {
      setValidateEmail(false)
    }

    if (!values.idClient || (valueCheckBox && !email)) {
      setEmptyError(true);
      funcValidate();
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");


    } else if (valueCheckBox && email && !validateEmailFunc(email)) {
      setValidateEmail(true);
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");


    } else if (!verifReCaptcha) {
      setEmptyError(true);
      props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");


    } else {
      setEmptyError(false);
      setValidateEmail(false);
      setErrorMessage("")
      setHandleButton(true)

    }
  }

  React.useEffect(() => {
    if (handleButton) {
      setLoading(true)
      dispatch({
        payload: { handleButton, email, typeCertificate, canal },
        type: ACTIONS.SET_JSON_BUTTON,
      });
      setHandleButton(false)
    }
  }, [handleButton])

  React.useEffect(() => {
    if (state.pagoCertificateWebContent) {
      setLoading(false)
      setHandleButton(false)
      if (state.pagoCertificateWebContent?.hasPayment) {
        setVisibleModal(true)
      } else {
        setVisibleModal(false)
      }
      if (state.pagoCertificateWebContent?.status === 500 || state.pdfCertificate?.message) {
        setErrorToggle(true);
        dispatch({
          payload: null,
          type: ACTIONS.SET_JSON_BUTTON,
        });
        setErrorMessage(state.pdfCertificate?.message ? decode_utf8(state.pdfCertificate?.message) : decode_utf8(props.text_fetch_error))
        setLoading(false);
      } else {
        setErrorToggle(false);
        setErrorMessage("");
      }
    }
  }, [state.pagoCertificateWebContent])


  React.useEffect(() => {
    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  React.useEffect(() => {
    if (!valueCheckBox) {
      setValidateEmail(false);
    }

  }, [valueCheckBox])
  function handleChangeNumberCliente(e) {
    setNumberClient(e.target.value)
  }

  function handleEmail(e) {
    setEmail(e.target.value)
  }

  React.useEffect(() => {
    if (confirm) {
      setLoading(true)
      dispatch({
        payload: confirm,
        type: ACTIONS.SET_CONFIRM
      })
      setConfirm(false)
    }
  }, [confirm])

  React.useEffect(() => {
    if (state.pdfCertificate) {
      setLoading(false);
      setHandleButton(false);
      dispatch({
        payload: null,
        type: ACTIONS.SET_PDF
      })
      if (state.pdfCertificate?.status === 500 || state.pdfCertificate?.message) {
        setErrorToggle(true);
        setErrorMessage(state.pdfCertificate?.message && state.pdfCertificate?.status !== 500 ? decode_utf8(state.pdfCertificate?.message) : decode_utf8(props.text_fetch_error))
        setLoading(false);
      } else {
        setErrorToggle(false);
        setErrorMessage("");
      }
    }

  }, [state.pdfCertificate])

  React.useEffect(() => {
    if (state.errorCatch?.message) {
      setErrorToggle(true);
      setErrorMessage(decode_utf8(props.text_fetch_error))
      setLoading(false);
    } else {
      setErrorToggle(false);
      setErrorMessage("");
    }
  }, [state.errorCatch])

  React.useEffect(() => {
    if (!valueCheckBox) {
      setEmail("")
    }
  }, [valueCheckBox])


  React.useEffect(() => {
    if (errorMessage) {
      props.setGlobalAlert(errorMessage, "warning", true, "Advertencia");
    }
  }, [errorMessage])

  React.useEffect(() => {
    if (state.detailClient && values.idClient) {
      setLoading(false)
      if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
        if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
          setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
          setDisabledButton(false);
        } else {
          setDetailClientJson([])
          props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
          setDisabledButton(true);
        }
      } else {
        setDetailClientJson([])
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setDisabledButton(true);

      }
    }
  }, [state.detailClient])

  function handleClickButtonClient() {
    if (values.idClient) {
      setErrorCli(false);
      dispatch({
        payload: values.idClient,
        type: ACTIONS.SET_IDCLIENT,
      });
      setLoading(true);
    } else {
      setErrorCli(true);
    }
  }

  function funcValidate() {
    let errors = {
      empty: {},
      validated: {},
      msg: {}
    };

    if (values.idClient) {
      errors.empty.idClient = false;
    } else {
      errors.empty.idClient = true;
      errors.msg.idClient = "Debe ingresar un Nro de Cliente"
    }

    setInputValidate(errors)
    return errors
  }

  return (
    <CGE.Panel
      title={title}
      description={description}
    >
      <div>
        <CGE.PanelContainer

          alingItensCenter={true}
        >
          <CGE.DetailClient
            props={{
              handleChange: (e) => {
                setValues({ ...values, idClient: e.target.value });
                setDetailClientJson([]);
                setDisabledButton(true);
              },
              handleClick: () => { handleClickButtonClient() },
              hasError: (errorCli || inputValidate?.empty?.idClient) || (values.idClient && detailClientJson?.length === 0 && verifReCaptcha),
              msgError: values.idClient && detailClientJson?.length === 0 && verifReCaptcha ?"Debes realizar la búsqueda del número de cliente.":"Debe ingresar un Nro de Cliente",
              idClient: values.idClient,
              idFormElement: "idClient",
              labelButton: "Buscar",
              labelName: "N° de Cliente",
              mandatoryElement: true,
              propsLabelInfoContent: propsLabelInfoContent,
              readOnly: urlParams.get('ctacto') ? true : false,
              sizeButton: "sm",
              typeButton: "primary",
              typeFormElement: "text",
              typeElement: "input-mask",
              maxLength: "12",
              formatChars: {
                9: "[0-9]"
              },
              mask: "999999999999",
              valuePub: values.idClient

            }}
            propsDetail={{
              fullNameClient: "",
              comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
              calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
              nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
              dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
              ${detailClientJson?.PISO}` : "",
              ctaCtoClient: detailClientJson?.CTA_CTO
            }}
          />
          <CGE.FormsField
            checked={valueCheckBox}
            horizontal={true}
            labelName="Enviar certificado por correo electrónico"
            handleChange={() => setValueCheckBox((val) => !val)}
            idFormElement="numberClientId"
            typeFormElement="checkbox"
            mandatoryElement={false}
            typeElement="input"
          />
          {valueCheckBox &&
            <>
              <CGE.FormsField
                horizontal={true}
                checked={valueCheckBox}
                handleChange={(e) => handleEmail(e)}
                idFormElement="numberClientId"
                mandatoryElement={valueCheckBox}
                labelName="Correo Electrónico"
                typeElement="input"
                placeholder="Ingresar el correo electrónico"
                hasError={(emptyError && !email && valueCheckBox) || (validateEmail && valueCheckBox) ? true : false}
                msgError={valueCheckBox && "Debes ingresar un Correo Electrónico válido para el Titular."}
              />
            </>}

          {!getPageLayoutType() &&
            <CGE.FieldRecaptcha
              onChange={onChangeReCaptcha}
              sitekey={decode_utf8(props.api_key_recaptcha)}
              horizontal={true}
            />
          }
        </CGE.PanelContainer>
        <CGE.Button
          disabled={disabledButton}
          className="mx-auto"
          label="Ver Certificado"
          onClick={() => handleClickButton()}
          type="primary"
        />
      </div>

      {loading && <Loading />}
      {visibleModal && !loading && (
        <AlertModal
          titleModal="Información"
          observer={observer}
          onClose={() => {
            onClose()
            dispatch({
              payload: null,
              type: ACTIONS.SET_JSON_BUTTON,
            })
          }}
          status="info"
          confirm="true"
          funcClick={() => {
            setConfirm(true);
            onClose();
          }}
        >
          <CGE.RenderContent textContent={state.pagoCertificateWebContent?.htmlContent} />
        </AlertModal>
      )}
    </CGE.Panel>
  )
}

const DebtAndEndowmentPublicWithProvider = ({
  props,
  title,
  description,
  typeCertificate,
  canal

}) => (
  <DebtAndEndowmentContextProvider>
    <DebtAndEndowmentPublic
      props={props}
      title={title}
      description={description}
      typeCertificate={typeCertificate}
      canal={canal}
    />
  </DebtAndEndowmentContextProvider>
);

export default DebtAndEndowmentPublicWithProvider;